import React from "react";

import { useNavigate } from "react-router-dom";
import ModalModal from "modals/Modal";
import { Column, Row, Img, Text, List, Stack, Line } from "components";

const DashboardPage = () => {
  const navigate = useNavigate();
  const [isOpenModalModal, setModalModal] = React.useState(false);

  function handleNavigate2() {
    navigate("/createmetrics");
  }
  function handleOpenModalModal() {
    setModalModal(true);
  }
  function handleCloseModalModal() {
    setModalModal(false);
  }

  return (
    <>
      <Column className="bg-white_A700 font-inter items-center justify-end mx-[auto] lg:pt-[35px] xl:pt-[40px] 2xl:pt-[45px] 3xl:pt-[54px] lg:px-[35px] xl:px-[40px] 2xl:px-[45px] 3xl:px-[54px] w-[100%]">
        <Row className="items-center w-[94%]">
          <Img
            src="images/img_group_35X162.svg"
            className="lg:h-[28px] xl:h-[32px] 2xl:h-[36px] 3xl:h-[43px] w-[13%]"
            alt="Group"
          />
          <Text className="font-medium lg:ml-[645px] xl:ml-[738px] 2xl:ml-[830px] 3xl:ml-[996px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-blue_A700 w-[auto]">
            Dashboard
          </Text>
          <Text
            className="common-pointer font-medium lg:ml-[38px] xl:ml-[43px] 2xl:ml-[49px] 3xl:ml-[58px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900_87 w-[auto]"
            onClick={handleNavigate2}
          >
            Create Metrics
          </Text>
        </Row>
        <List
          className="gap-[0] min-h-[auto] lg:mt-[46px] xl:mt-[53px] 2xl:mt-[60px] 3xl:mt-[72px] w-[94%]"
          orientation="vertical"
        >
          <Column className="bg-white_A700 justify-end lg:my-[11px] xl:my-[13px] 2xl:my-[15px] 3xl:my-[18px] lg:p-[23px] xl:p-[26px] 2xl:p-[30px] 3xl:p-[36px] rounded-radius12 shadow-bs w-[100%]">
            <Row className="items-center mr-[auto] mt-[1px] w-[24%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Metrics Name :
              </Text>
              <Text className="font-medium lg:ml-[18px] xl:ml-[21px] 2xl:ml-[24px] 3xl:ml-[28px] lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-bluegray_401 w-[auto]">
                XYZ Matrics
              </Text>
            </Row>
            <Row
              className="bg-cover bg-repeat items-center lg:mt-[19px] xl:mt-[22px] 2xl:mt-[25px] 3xl:mt-[30px] lg:p-[12px] xl:p-[14px] 2xl:p-[16px] 3xl:p-[19px] rounded-radius6 w-[100%]"
              style={{ backgroundImage: "url('images/img_group216.svg')" }}
            >
              <Column className="lg:ml-[57px] xl:ml-[65px] 2xl:ml-[74px] 3xl:ml-[88px] pb-[1px] pr-[1px] w-[29%]">
                <Text className="font-normal lg:mr-[161px] xl:mr-[184px] 2xl:mr-[207px] 3xl:mr-[248px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Sub-Categories
                </Text>
                <Column className="lg:ml-[47px] xl:ml-[54px] 2xl:ml-[61px] 3xl:ml-[73px] lg:mt-[26px] xl:mt-[30px] 2xl:mt-[34px] 3xl:mt-[40px] w-[7%]">
                  <Text className="flex font-normal items-center not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D1
                  </Text>
                  <Text className="font-normal lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D2
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D3
                  </Text>
                </Column>
              </Column>
              <Column className="items-center mt-[2px] pb-[1px] pr-[1px] w-[28%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Current Month
                </Text>
                <Column className="items-center lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] w-[4%]">
                  <Text
                    className="common-pointer font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]"
                    onClick={handleOpenModalModal}
                  >
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
              <Column className="items-center w-[22%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Next Month
                </Text>
                <Column className="items-center lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] w-[5%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
              <Column className="items-center w-[9%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Next Month
                </Text>
                <Column className="items-center lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] w-[12%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
            </Row>
            <Row className="items-center mr-[auto] lg:mt-[23px] xl:mt-[26px] 2xl:mt-[30px] 3xl:mt-[36px] w-[20%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Goal :
              </Text>
              <Text className="bg-yellow_300 flex font-bold items-center lg:ml-[14px] xl:ml-[16px] 2xl:ml-[19px] 3xl:ml-[22px] lg:px-[4px] xl:px-[5px] 2xl:px-[6px] 3xl:px-[7px] rounded-radius50 xl:text-[10px] 2xl:text-[12px] 3xl:text-[14px] lg:text-[9px] text-black_900 w-[40px]">
                89%
              </Text>
              <Text className="font-medium lg:ml-[15px] xl:ml-[17px] 2xl:ml-[20px] 3xl:ml-[24px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-blue_600 underline w-[auto]">
                See Full List
              </Text>
            </Row>
          </Column>
          <Column className="bg-white_A700 justify-end lg:my-[11px] xl:my-[13px] 2xl:my-[15px] 3xl:my-[18px] lg:p-[23px] xl:p-[26px] 2xl:p-[30px] 3xl:p-[36px] rounded-radius12 shadow-bs w-[100%]">
            <Row className="items-center mr-[auto] mt-[1px] w-[24%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Metrics Name :
              </Text>
              <Text className="font-medium lg:ml-[18px] xl:ml-[21px] 2xl:ml-[24px] 3xl:ml-[28px] lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-bluegray_401 w-[auto]">
                XYZ Matrics
              </Text>
            </Row>
            <Row
              className="bg-cover bg-repeat items-center lg:mt-[19px] xl:mt-[22px] 2xl:mt-[25px] 3xl:mt-[30px] lg:p-[12px] xl:p-[14px] 2xl:p-[16px] 3xl:p-[19px] rounded-radius6 w-[100%]"
              style={{
                backgroundImage: "url('images/img_group216_gray_50.svg')",
              }}
            >
              <Column className="lg:ml-[57px] xl:ml-[65px] 2xl:ml-[74px] 3xl:ml-[88px] pb-[1px] pr-[1px] w-[29%]">
                <Text className="font-normal lg:mr-[161px] xl:mr-[184px] 2xl:mr-[207px] 3xl:mr-[248px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Sub-Categories
                </Text>
                <Column className="lg:ml-[47px] xl:ml-[54px] 2xl:ml-[61px] 3xl:ml-[73px] lg:mt-[26px] xl:mt-[30px] 2xl:mt-[34px] 3xl:mt-[40px] w-[7%]">
                  <Text className="flex font-normal items-center not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D1
                  </Text>
                  <Text className="font-normal lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D2
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    D3
                  </Text>
                </Column>
              </Column>
              <Column className="items-center mt-[2px] pb-[1px] pr-[1px] w-[28%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Current Month
                </Text>
                <Column className="items-center lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] w-[4%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
              <Column className="items-center w-[23%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Next Month
                </Text>
                <Column className="items-center lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] w-[4%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
              <Column className="items-center w-[9%]">
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Next Month
                </Text>
                <Column className="items-center lg:mt-[27px] xl:mt-[31px] 2xl:mt-[35px] 3xl:mt-[42px] w-[12%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    X
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Y
                  </Text>
                  <Text className="font-normal lg:mt-[28px] xl:mt-[32px] 2xl:mt-[36px] 3xl:mt-[43px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                    Z
                  </Text>
                </Column>
              </Column>
            </Row>
            <Row className="items-center mr-[auto] lg:mt-[23px] xl:mt-[26px] 2xl:mt-[30px] 3xl:mt-[36px] w-[20%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Goal :
              </Text>
              <Text className="bg-yellow_300 flex font-bold items-center lg:ml-[14px] xl:ml-[16px] 2xl:ml-[19px] 3xl:ml-[22px] lg:px-[4px] xl:px-[5px] 2xl:px-[6px] 3xl:px-[7px] rounded-radius50 xl:text-[10px] 2xl:text-[12px] 3xl:text-[14px] lg:text-[9px] text-black_900 w-[40px]">
                89%
              </Text>
              <Text className="font-medium lg:ml-[15px] xl:ml-[17px] 2xl:ml-[20px] 3xl:ml-[24px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-blue_600 underline w-[auto]">
                See Full List
              </Text>
            </Row>
          </Column>
          <Column className="bg-white_A700 lg:my-[11px] xl:my-[13px] 2xl:my-[15px] 3xl:my-[18px] lg:p-[19px] xl:p-[22px] 2xl:p-[25px] 3xl:p-[30px] rounded-radius12 shadow-bs w-[100%]">
            <Row className="items-center ml-[4px] w-[23%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Metrics Name :
              </Text>
              <Text className="font-medium lg:ml-[18px] xl:ml-[21px] 2xl:ml-[24px] 3xl:ml-[28px] lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-bluegray_401 w-[auto]">
                XYZ Matrics
              </Text>
            </Row>
            <Stack className="lg:h-[168px] xl:h-[193px] 2xl:h-[217px] 3xl:h-[260px] ml-[4px] lg:mt-[24px] xl:mt-[27px] 2xl:mt-[31px] 3xl:mt-[37px] w-[99%]">
              <Stack className="absolute bg-gray_50 border border-indigo_100 border-solid lg:h-[168px] xl:h-[193px] 2xl:h-[217px] 3xl:h-[260px] pl-[1px] rounded-radius6 w-[100%]">
                <Stack className="absolute lg:h-[167px] xl:h-[191px] 2xl:h-[215px] 3xl:h-[257px] inset-[0] justify-center m-[auto] w-[100%]">
                  <Line className="absolute bg-indigo_101 lg:h-[167px] xl:h-[191px] 2xl:h-[215px] 3xl:h-[257px] left-[27%] w-[1px]" />
                  <Column className="absolute inset-y-[24%] items-center w-[100%]">
                    <Line className="bg-indigo_101 h-[1px] rotate-[180deg] w-[100%]" />
                    <Line className="bg-indigo_101 h-[1px] lg:mt-[41px] xl:mt-[47px] 2xl:mt-[53px] 3xl:mt-[63px] rotate-[180deg] w-[100%]" />
                    <Line className="bg-indigo_101 h-[1px] lg:mt-[41px] xl:mt-[47px] 2xl:mt-[53px] 3xl:mt-[63px] rotate-[180deg] w-[100%]" />
                  </Column>
                </Stack>
                <Line className="absolute bg-indigo_101 lg:h-[167px] xl:h-[191px] 2xl:h-[215px] 3xl:h-[257px] inset-y-[0] my-[auto] right-[45%] w-[1px]" />
                <Line className="absolute bg-indigo_101 lg:h-[167px] xl:h-[191px] 2xl:h-[215px] 3xl:h-[257px] inset-y-[0] my-[auto] right-[20%] w-[1px]" />
              </Stack>
              <Row className="absolute h-[max-content] inset-[0] justify-center m-[auto] w-[85%]">
                <List
                  className="lg:gap-[162px] xl:gap-[185px] 2xl:gap-[209px] 3xl:gap-[250px] grid grid-cols-2 min-h-[auto] w-[46%]"
                  orientation="horizontal"
                >
                  <Column className="w-[100%]">
                    <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                      Sub-Categories
                    </Text>
                    <Column className="lg:ml-[47px] xl:ml-[54px] 2xl:ml-[61px] 3xl:ml-[73px] lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] w-[19%]">
                      <Text className="flex font-normal items-center not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        D1
                      </Text>
                      <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        D2
                      </Text>
                      <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        D3
                      </Text>
                    </Column>
                  </Column>
                  <Column className="items-center w-[100%]">
                    <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                      Current Month
                    </Text>
                    <Column className="items-center lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] w-[10%]">
                      <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        X
                      </Text>
                      <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        Y
                      </Text>
                      <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                        Z
                      </Text>
                    </Column>
                  </Column>
                </List>
                <Column className="items-center pb-[1px] w-[10%]">
                  <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                    Next Month
                  </Text>
                  <Column className="items-center lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] w-[12%]">
                    <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                      X
                    </Text>
                    <Text className="font-normal lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-gray_600 w-[auto]">
                      Y
                    </Text>
                  </Column>
                  <Row className="items-center justify-between lg:mt-[24px] xl:mt-[28px] 2xl:mt-[32px] 3xl:mt-[38px] w-[71%]">
                    <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-bluegray_400 w-[auto]">
                      N/A
                    </Text>
                    <Img
                      src="images/img_plus.svg"
                      className="lg:h-[16px] xl:h-[18px] 2xl:h-[21px] 3xl:h-[25px] lg:w-[15px] xl:w-[17px] 2xl:w-[20px] 3xl:w-[24px]"
                      alt="plus"
                    />
                  </Row>
                </Column>
                <Text className="font-normal not-italic lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-black_900 w-[auto]">
                  Next
                </Text>
              </Row>
            </Stack>
            <Row className="items-center mb-[4px] ml-[4px] lg:mt-[23px] xl:mt-[26px] 2xl:mt-[30px] 3xl:mt-[36px] w-[19%]">
              <Text className="font-medium lg:text-[15px] xl:text-[17px] 2xl:text-[20px] 3xl:text-[24px] text-black_900 w-[auto]">
                Goal :
              </Text>
              <Text className="bg-yellow_300 flex font-bold items-center lg:ml-[14px] xl:ml-[16px] 2xl:ml-[19px] 3xl:ml-[22px] lg:px-[4px] xl:px-[5px] 2xl:px-[6px] 3xl:px-[7px] rounded-radius50 xl:text-[10px] 2xl:text-[12px] 3xl:text-[14px] lg:text-[9px] text-black_900 w-[40px]">
                89%
              </Text>
              <Text className="font-medium lg:ml-[15px] xl:ml-[17px] 2xl:ml-[20px] 3xl:ml-[24px] lg:text-[14px] xl:text-[16px] 2xl:text-[18px] 3xl:text-[21px] text-blue_600 underline w-[auto]">
                See Full List
              </Text>
            </Row>
          </Column>
        </List>
      </Column>

      {isOpenModalModal ? (
        <ModalModal
          isOpen={isOpenModalModal}
          onRequestClose={handleCloseModalModal}
        />
      ) : null}
    </>
  );
};

export default DashboardPage;
